import { MATISSE_BLUE, WHITE } from "../../../constants/colors";

const searchIconColor = WHITE;
const searchIconBackgroundColor = MATISSE_BLUE;

export const fallbackValues = {
  searchIconColor,
  searchIconBackgroundColor
};
